// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

type RuntimeHostSettings = Partial<{
    layout: {
        theme?: string;
        logo?: string;
        watermark?: string;
        favicon?: string;
    };
    support: {
        email?: string;
        mobile?: string;
        fullname?: string;
    };
    app: {
        name?: string;
        code?: string;
        avatar?: string;
    };
    organization: {
        id?: number;
        name?: string;
        code?: string;
    };
    branch: {
        id?: number;
        name?: string;
        code?: string;
    };
    user: {
        email?: string;
        fullname?: string;
        lastname?: string;
        othernames?: string;
        role?: string[];
        superadmin?: boolean;
        avatar?: string;
    };
}>;

declare global {
    interface Window {
        settings?: RuntimeHostSettings;
    }
}

const settings: RuntimeHostSettings = typeof window !== 'undefined'
    ? window.settings ?? {}
    : {};

export const environment = {
    production: false,
    url: {
        api: 'https://api.ashcorp.xyz',
        web: 'https://demo.ashcorp.xyz',
        mobile: 'https://mobile.ashcorp.co'
    },
    app: {
        name: settings.app?.name || 'DEMO',
        code: settings.app?.code || 'DEMO'
    },
    layout: {
        logo: settings.layout?.logo || 'https://cloud.ashcorp.co/index.php/s/fX7kZWEkEysJrqb/download/logo-20260328151452-e9f33243.png',
        theme: settings.layout?.theme || 'default',
        watermark: settings.layout?.watermark || 'https://cloud.ashcorp.co/index.php/s/Btp2mpragCTSniC/download/watermark-20260328151320-0bcf126c.png',
        favicon: settings.layout?.favicon || 'https://cloud.ashcorp.co/index.php/s/MwMofkqidT9pYPZ/download/favicon-20260328151518-4af7f78e.png'
    },
    support: {
        email: settings.support?.email || 'support@ashcorp.co',
        mobile: settings.support?.mobile || '59729663',
        fullname: settings.support?.fullname || 'Addams',
    },
    user: {
        email: '',
        fullname: '',
        lastname: '',
        othernames: '',
        role: [],
        superadmin: false,
        avatar: settings.user?.avatar || 'https://cloud.ashcorp.co/index.php/s/g7ewbkDSAY6eTC3/download/avatar-20260328152021-746da634.jpeg'
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
